import React, { useEffect, useRef, useState } from "react";
import "../common/common.css";
import "../common/style.css";
import "../common/responsive.css";
import { JOURNEY_CONTENT } from "../../shared/config/journeyConfig";
import experienceImg from "../../assets/images/Experience.png";
import citiesImg from "../../assets/images/Cities.png";
import warehouseImg from "../../assets/images/Warehouse.png";
const JourneySection = () => {
  const [experienceYears, setExperienceYears] = useState(0);
  const [cities, setCities] = useState(0);
  const [warehouse, setWarehouse] = useState(0);
  const [households, setHouseholds] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);

  const sectionRef = useRef<HTMLDivElement | null>(null);

  const totalDuration = 3000; // Total animation duration in milliseconds
  const experienceTarget = 18; // Target for years of experience
  const citiesTarget = 25; // Target for cities
  const householdsTarget = 150000; // Target for households (35 million or 350 lakh)
  const warehouseTarget = 75;
  useEffect(() => {
    const handleIntersection = (entries: IntersectionObserverEntry[]) => {
      const entry = entries[0];
      if (entry.isIntersecting && !hasAnimated) {
        setHasAnimated(true);
        startCounting();
      }
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.5, // Trigger when 50% of the section is visible
    });

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [hasAnimated]);

  const startCounting = () => {
    const interval = 50; // Update interval in milliseconds
    const totalSteps = totalDuration / interval;

    const experienceIncrement = experienceTarget / totalSteps;
    const citiesIncrement = citiesTarget / totalSteps;
    const warehouseIncrement = warehouseTarget / totalSteps;
    const householdsIncrement = householdsTarget / totalSteps;

    let currentExperience = 0;
    let currentCities = 0;
    let currentWarehouse = 0;
    let currentHouseholds = 0;

    const countingInterval = setInterval(() => {
      currentExperience = Math.min(
        currentExperience + experienceIncrement,
        experienceTarget
      );
      setExperienceYears(Math.round(currentExperience));

      currentCities = Math.min(
        currentCities + citiesIncrement,
        citiesTarget
      );
      setCities(Math.round(currentCities));

      currentWarehouse = Math.min(
        currentWarehouse + warehouseIncrement,
        warehouseTarget
      );
      setWarehouse(Math.round(currentWarehouse));

      currentHouseholds = Math.min(
        currentHouseholds + householdsIncrement,
        householdsTarget
      );
      setHouseholds(Math.round(currentHouseholds));

      if (
        Math.round(currentExperience) === experienceTarget &&
        Math.round(currentCities) === citiesTarget &&
        Math.round(currentWarehouse) === warehouseTarget &&
        Math.round(currentHouseholds) === householdsTarget
      ) {
        clearInterval(countingInterval);
      }
    }, interval);
  };

  return (
    <section className="journey" ref={sectionRef}>
      <div className="container">
        <div className="journeyHeading">
          <h2 className="headingsText">{JOURNEY_CONTENT.heading}</h2>
        </div>

        <div className="journeyDetails row">
          <div className="journeyCounts col-md-4 text-center">
            <img
              src={experienceImg}
              alt="Years of Experience"
              className="journeyIcon"
              width={100}
              height={100}
            />
            <h2 className="counts">
              {experienceYears}
              {JOURNEY_CONTENT.experience.suffix}
            </h2>
            <h3 className="journeyText">
              {JOURNEY_CONTENT.experience.description}
            </h3>
          </div>

          <div className="journeyCounts col-md-4">
            <img src={citiesImg} alt="Cities" className="journeyIcon" width={100}
              height={100} />

            <h2 className="counts">
              {cities}
              {JOURNEY_CONTENT.cities.suffix}
            </h2>
            <h3 className="journeyText">
              {JOURNEY_CONTENT.cities.description}
            </h3>
          </div>

          <div className="journeyCounts col-md-4">
            <img src={warehouseImg} alt="Warehouse" className="journeyIcon" width={100}
              height={100} />

            <h2 className="counts">
              {warehouse}
              {JOURNEY_CONTENT.warehouse.suffix}
            </h2>
            <h3 className="journeyText">
              {JOURNEY_CONTENT.warehouse.description}
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JourneySection;